import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=7cb41050&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"
import style0 from "./Search.vue?vue&type=style&index=0&id=7cb41050&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb41050",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitrix/ext_www/igr.ru/local/templates/main/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cb41050')) {
      api.createRecord('7cb41050', component.options)
    } else {
      api.reload('7cb41050', component.options)
    }
    module.hot.accept("./Search.vue?vue&type=template&id=7cb41050&scoped=true", function () {
      api.rerender('7cb41050', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Search.vue"
export default component.exports